<template>
	<div class="content-sidebar">
		<!-- Validacion observacion-->
      <!--<div class="order-out" v-show="exit_component">
        <div class="canceled-info">
          <i id="id_icons"></i>
          <h4>Seleccione una combinacion.</h4>
          <div class="exit-options">
            <button @click="exit_component=false" >OK</button>
          </div>
        </div>
      </div>-->
      <!--- Fin Validacion-->

		<div class="header-sidebar">
			<div class="product-name">
				<h5>{{ product.name_product }}</h5>
				<p style="text-align: justify!important;">{{ product.description }}</p>	
			</div>
			<div class="close-sidebar">
				<i class="fas fa-times" :style="{ color: botones}" @click="close()"></i>
			</div>
		</div>
		<div class="title-combination" v-if="product.statusVariants">
			<h5>Opciones</h5>
			<span :style="{ backgroundColor: botones}">obligatorio</span>
		</div>
		<div v-if="!combination_default_first">
			<div  class="combinaciones-product" v-for="(variant,i) in product.variants" :key="i">
				<strong><h5 class="izquierda">{{ variant.name_variant }}</h5></strong>

				<select 
					name="select" 
					:id="variant.name_variant+'_'+variant.id_product" 
					@change="getPriceProductCombination()"
				>
					<option value="0" disabled selected>Seleccionar Opción</option>
					<option 
						v-for="(detail, i) in product.variant_detail.filter(d => d.id_product_variant == variant.id_product_variant)" 
						:key="i" 
						:value="variant.name_variant+'_'+detail.option"
					>
						{{ detail.option }} 
						<span v-if="id_company != 7054 && id_company != 6650"> + ${{ new Intl.NumberFormat("de-DE").format(detail.value) }}</span>
					</option>
				</select>

				
			</div>
		</div>
		<div v-if="combination_default_first">
			<div  class="combinaciones-product" v-for="(variant,i) in product.variants" :key="i">
				<strong><h5 class="izquierda">{{ variant.name_variant }}</h5></strong>
				<select name="select" :id="variant.name_variant+'_'+variant.id_product" @change="getPriceProductCombination()">
					<option 
						v-for="(detail, i) in product.variant_detail.filter(d => d.id_product_variant == variant.id_product_variant)" 
						:key="i" 
						:value="variant.name_variant+'_'+detail.option"
					>
						{{ detail.option }}
					</option>
				</select>
				
				
				
			</div>
		</div>
		<div class="avaliability" style="width: 100%; text-align: left;padding: 10px 20px;" v-if="state_stock">
			<span :style="{ color: botones}">Unidades disponibles: {{ avaliability }}</span>
		</div>
		<!--<div class="title-combination" v-if="product.statusAdditions">
			<h5>Adiciones</h5>
			
		</div>-->
		<div class="combinations" v-for="(addition,index) in product.additions" :key="index">
			<div style="width: 100%;text-align: left;padding-bottom: 10px;display: flex;justify-content: space-between;">
				<strong>
					<h5 style="font-size: 19px !important;font-weight: 500 !important;margin-bottom: 0 !important;">
						{{ addition.name_addition}}
					</h5>
				</strong>
				<span :style="{ backgroundColor: botones }" class="use-limite" v-if="addition.limite > 0">
					Máximo: {{ addition.limite }} 
					<span v-if="refreshList(addition.id_product_addition) > 0">
						({{ addition.limite - refreshList(addition.id_product_addition) }} restantes)
					</span>
				</span>
				<span :style="{ backgroundColor: botones}" class="use-limite" v-if="addition.id_tipo == 139">Obligatorio</span>
				<span :style="{ backgroundColor: botones}" class="use-limite" v-if="addition.id_tipo == 140">Opcional</span>
			</div>
			<div 
				class="custom-adittions" 
				v-for="(detail) in product.addition_detail.filter(d => d.id_product_addition == addition.id_product_addition)" 
				:key="detail.id_product_addition_detail" 
				:id="'adiciones-' + detail.id_product_addition_detail"
			>
 			 	<div class="addition-name">
 			 		<h4>{{ detail.option }}</h4>
 			 		<h5 :style="{ color: botones}">${{ currency == 'COP' ? new Intl.NumberFormat("de-DE").format(detail.value) : detail.value }}</h5>
 			 		<span 
 			 			v-if="!canAddMore(addition.id_product_addition, addition.limite)" 
 			 			class="limit-reached-message"
 			 			:style="{ color: '#ff4444' }"
 			 		>
 			 			Límite alcanzado
 			 		</span>
 			 	</div>
 			 	<div class="addition-quantity">
 			 		<div class="remove-quantity" :style="{ backgroundColor: botones}">
 			 			<i class="fas fa-minus" @click="removeQuantity(detail, addition.limite, addition.id_product_addition, detail.id_product_addition_detail)"></i>
 			 		</div>
 			 		<div class="quantity-number">
 			 			<h4>{{ detail.quantity }}</h4>
                        <h4 v-show="algo=false">{{quantity}}</h4>
 			 		</div>
 			 		<div 
 			 			class="add-quantity" 
 			 			:style="{ 
 			 				backgroundColor: !canAddMore(addition.id_product_addition, addition.limite) ? '#ccc' : botones,
 			 				cursor: !canAddMore(addition.id_product_addition, addition.limite) ? 'not-allowed' : 'pointer'
 			 			}"
 			 			:class="{ 'disabled': !canAddMore(addition.id_product_addition, addition.limite) }"
 			 		>
 			 			<i 
 			 				class="fas fa-plus" 
 			 				@click="canAddMore(addition.id_product_addition, addition.limite) && addQuantity(detail, addition.limite, addition.id_product_addition, detail.id_product_addition_detail)"
 			 			></i>
 			 		</div>
 			 	</div>	
 			</div>
			<!--<div class="inputGroup" v-for="(detail,i) in product.addition_detail" :key="i" v-if="detail.id_product_addition == addition.id_product_addition">
    			<input :id="detail.id_product_addition_detail" type="checkbox" @click="validateCheckAddition(detail.id_product_addition_detail,detail.option,detail.value,addition.limite,addition.id_product_addition)"/>
   				<label :for="detail.id_product_addition_detail">{{ detail.option }} &nbsp;<strong v-if="detail.value > 0">${{ currency == 'COP' ? new Intl.NumberFormat("de-DE").format(detail.value) : detail.value }}</strong></label>
 			 </div>-->
		</div>
		<div class="title-combination" v-show="activate_observation">
			<h5>Observaciones</h5>
			<span :style="{ backgroundColor: botones}">opcional</span>
		</div>
		<div class="observation-general" v-show="activate_observation">
			<textarea placeholder="Observaciones" v-model="form.observation_optional"></textarea>
		</div>
		<div v-show="exit_component" class="exit_component" :class="{ shake: isShaking }">
			<h5 style="color:red;">Seleccione una combinación, por favor.</h5>
		</div>
		<div v-show="exit_component2" class="exit_component" :class="{ shake: isShaking }">
			<h5 style="color:red;">Seleccione una opción, por favor.</h5>
		</div>

		<!--Seccion Dividir Cuenta-->
		
		<div class="split_bill" v-if="mesero">
			<h5 style="font-size: 19px !important;font-weight: 500 !important;margin-bottom: 0 !important;">Dividir Cuenta? </h5>
			<select name="select" v-model="form.name_client">
			  <option value="" disabled selected>No</option>
			  <option v-for="(item, i) in clients_order" :key="i" :value="item">
				{{ item }}
			  </option>
			  <option value="nuevo">+ Nuevo</option> <!-- Opción para añadir un cliente nuevo -->
			</select>
		  
			<!-- Input y botón se muestran solo si se elige "+ Nuevo" -->
			<div v-if="form.name_client === 'nuevo'" style="display: flex; gap: 10px;">
			  <input type="text" v-model="new_client" placeholder="Nombre del cliente">
			  <button @click="addNewClient">Añadir</button>
			</div>
		</div>

		<!--Fin Seccion Dividir Cuenta-->


		<!--<div style="height:140px;"></div>-->
		<div class="total-amount" v-bind:class="{ 'total-amount-kiosko': kiosko == 'true' }">
			<div class="quantity">
				<div class="less" >
					<i class="fas fa-minus" @click="minus()"></i>
				</div>
				<div class="quantity-value">
					<label :style="kiosko == 'true' ? { fontSize: '30px' } : {}">{{ form.quantity }}</label>
				</div>
				<div class="more">
					<i class="fas fa-plus" @click="plus()"></i>
				</div>
			</div>
			<div id="btn_agregar" class="shop-product" :class="{ 'shop-product-kiosko': kiosko == 'true', shake: isShaking }" :disabled="isDisabled" :style="{ backgroundColor: botones}" @click="handleClick" >
				<h5 :style="kiosko == 'true' ? { fontSize: '30px' } : {}"><strong>Agregar</strong> ${{ currency == 'COP' 
					? new Intl.NumberFormat("de-DE").format((form.unit_price * form.quantity) + (multiply_addition_product ? (addition_v * form.quantity) : addition_v)) 
					: (form.unit_price * form.quantity) + (multiply_addition_product ? (addition_v * form.quantity) : addition_v)  }} </h5>
			</div>
		</div>


	</div>
</template>

<style lang="scss" scoped>
	.split_bill{
		border-top: 1px solid #ddd;
		padding-top: 15px;
		display: flex; 
		align-items: center; 
		gap: 10px;
	}


.exit_component {
    display: flex;
    justify-content: center; /* Centra horizontalmente */
    align-items: center; /* Centra verticalmente */
    position: fixed;
    z-index: 11;
    width: 100%;
    bottom: 20%;
    text-align: center; /* Asegura que el texto esté centrado dentro de su elemento */
}


	@keyframes shake {
	0% { transform: translateX(0); }
	25% { transform: translateX(-5px); }
	50% { transform: translateX(5px); }
	75% { transform: translateX(-5px); }
	100% { transform: translateX(0); }
	}

	.shake {
	animation: shake 0.3s ease-in-out;
	}
	.observation-general{
		width:100%;
		text-align:center;
		padding:20px;
	}

	.observation-general textarea {
		width: 100%;
		border-radius:10px;
		border:1px solid #ddd;
		padding: 15px 10px 40px 10px;
	}


	.animation{
		animation: cambiar .3s ease-in;
	}

	@keyframes cambiar {
		from{
			background-color: rgba(0,0,0,.3);
		}
		to{
			background-color: transparent;
		}
	}

	.custom-adittions{
		width: 100%;
		height:auto;
		padding:10px 5px;
		/*margin-right:10px;
		margin-left: 10px;*/
		border-bottom: 1px solid #ddd;
		display:flex;
		justify-content:space-between;
		align-items:center;
		cursor: pointer;
	}

	.quantity-number{
		width:40%;
	}

	.quantity-number h4{
		margin-bottom: 0;
		font-size:17px;
		font-weight: 500;
		color: #000;
	}

	.addition-name{
		width: 80%;
		display:block;
		text-align:left;
	}

	.addition-name h4{
		font-size:16px;
		font-weight:500;
		margin-bottom:1px;
	}

	.addition-name h5{
		font-size:14px;
		font-weight:600;
		margin-bottom:1px;
	}

	.addition-quantity{
		width:20%;
		display:flex;
		justify-content:center;
		align-items:center;
	}

	.addition-quantity i{
		font-size:11px;
	}

	.remove-quantity, .add-quantity{
		width: 22px;
		height:22px;
		border-radius:50%;
		display:flex;
		justify-content:center;
		align-items:center;
		padding:10px;
		color: #fff;
	}

	.add-quantity.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	.limit-reached-message {
		font-size: 12px;
		font-weight: 500;
		font-style: italic;
	}

	.use-limite{
		text-transform: uppercase;
		background: #000;
		padding: 3px 5px 3px 5px;
		font-size: 12px;
		color: white;
		border-radius: 5px;
		align-self: center;
		margin-right: 10px;
	}
	
	@media only screen and (min-width: 1280px) and (max-width: 1920px){
		.exit_component {
			width: 45%;
		}
 		.content-sidebar{
 			width: 60% !important;
 			height: auto;
 			margin: 0 auto;
 		}
 		.total-amount{
 			width: 42% !important;
 			margin: 0 auto;
 		}
		.landscape-image {
			width: 100% !important;
			max-width: 100vw;
			height: 100vh;
		}
	}
	
	@media only screen and (min-width: 1280px) {
		.btn-footer-kiosko {
			font-size: 22px;
			padding: 15px 25px;
		}

	}

	@media only screen and (min-width: 1921px){
		.exit_component {
			width: 66%;
		}
		.total-amount{
 			width: 66% !important;
 			margin: 0 auto;
 		}
		.content-sidebar{
 			width: 66% !important;
 			height: auto;
 			margin: 0 auto;
 		}
	}



	.content-sidebar{
		overflow: hidden;
		width: 100%;
		padding-bottom: 200px;
		height:auto;
	}
	.izquierda{
		text-align: left !important;
		font-size: 17px !important;
	}
	.total-amount{
		width: 100%;
		background-color: white;
		display: flex;
		justify-content: space-between;
		padding: 20px 10px 20px 10px;
		position: fixed;
		bottom: 0;
		box-shadow: 0px 0px 8px 0px rgba(214,211,214,1);
		z-index: 10;
	}

	.total-amount-kiosko {
		padding: 25px 20px;
		font-size: 30px;
	}

	.total-amount-kiosko .label {
		padding: 25px 20px;
		font-size: 30px;
	}

	

	.shop-product-kiosko h5 {
		font-size: 22px; /* Texto del botón más grande */
	}


	.shop-product{
		width: 60%;
		background: #000;
		padding: 17px 15px 17px 15px;
		border-radius: 7px;
		align-self:center;
	}

	.shop-product h5{
		font-size: 18px;
		font-weight: 500;
		color: white;
		margin-bottom: 0 !important;
		align-self:center;
	}

	.quantity{
		width: 35%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border: 2px solid gray;
		border-radius: 7px;
		padding: 13px 15px 13px 15px;
	}

	.quantity i{
		color: #000;
	}

	.quantity label{
		font-size: 17px;
		margin-bottom: 0 !important;
	}
	.title-combination{
		display: flex;
		justify-content: space-between;
		padding: 17px 20px 17px 20px;
		background: #F2F2F2;
	}
	.title-combination h5{
		font-size: 20px;
		font-weight: 500;
		align-self: center;
		margin-bottom: 0 !important;
	}
	.title-combination span{
		text-transform: uppercase;
		background: #000;
		padding: 3px 5px 3px 5px;
		font-size: 12px;
		color: white;
		border-radius: 5px;
		align-self: center;
	}

	.header-sidebar{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: auto;
		padding:20px;
	}

	.product-name{
		width: 80%;
		text-align: left;
	}

	.product-name h5{
		font-size: 25px;
		margin-bottom:0 !important;
	}

	.close-sidebar{
		width: 20%;
		text-align: right;
	}
	.close-sidebar i{
		font-size: 31px;
	}

	.combinaciones-product{
		width: 100%;
		padding: 15px 20px 0px 20px;
		text-align: left;
	}

	.combinaciones-product select{
		width: 100%;
		padding-top: 15px;
		padding-bottom: 15px;
		padding-left: 8px;
		padding-right: 15px;
		color: #51565A;
		background-color: #EAF0FD;
		cursor: pointer;
		border: none;
		border-radius: 5px;
		box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
		margin-bottom: 10px;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	}

	.combinaciones-product select:focus{
		outline: none;
	}

	.combinations{
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		margin-top: 10px;
		padding-left: 15px;
		padding-right: 15px;
		padding-top: 10px;
		padding-bottom: 5px;
	}

	.inputGroup {
	    background-color: #fff;
	    width: 48%;
	    margin-bottom: 10px;
	    margin-right: 5px;
	    border: 2px solid #F2F2F2; 
	    position: relative;
	    align-self: center;

    label {
      padding: 12px 30px 12px 3px;
      width: 100%;
      display: block;
      text-align: left;
      color: #3C454C;
      cursor: pointer;
      position: relative;
      z-index: 2;
      transition: color 200ms ease-in;
      overflow: hidden;
      margin-bottom: 0 !important;

      &:before {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        content: '';
        background-color: #002767;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale3d(1, 1, 1);
        transition: all 300ms cubic-bezier(0.4, 0.0, 0.2, 1);
        opacity: 0;
        z-index: -1;
      }

      &:after {
        width: 26px;
        height: 26px;
        content: '';
        border: 2px solid #D1D7DC;
        background-color: #fff;
        background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
        background-repeat: no-repeat;
        background-position: -2px -1px;
        border-radius: 50%;
        z-index: 2;
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        transition: all 200ms ease-in;
      }
    }

    input:checked ~ label {
      color: #fff;

      &:before {
        transform: translate(-50%, -50%) scale3d(56, 56, 1);
        opacity: 1;
      }

      &:after {
        background-color: #81EDD5;
        border-color: #81EDD5;
      }
    }

    input {
      width: 32px;
      height: 32px;
      order: 1;
      z-index: 2;
      position: absolute;
      right: 30px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;
      visibility: hidden;
    }
  }

  .order-out{
      width: 100%;
      height: 110vh;
      position: fixed;
      top: 0;
      background-color: rgba(0, 0, 0, .6);
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .canceled-info{
      background: #fff;
      width: 80%;
      margin: 0 auto;
      padding-top: 20px;
      text-align: center;
      display: block;
      border-radius: 10px;
    }

    .canceled-info i{
      color: #E43A3A;
      font-size: 29px;
    }

    .canceled-info h4{
      font-family: 'Poppins', sans-serif;
      font-size: 17px;
      font-weight: 500;
      padding-top: 14px;
    }

    .canceled-info button{
      width: 100%;
      border-bottom: none;
      border-left: none;
      border-right: none;
      background: transparent;
      border-top: 1px solid #E8E8E8;
      margin-top: 10px;
      padding-top: 15px;
      padding-bottom: 15px;
      font-family: 'Poppins', sans-serif;
    }

    .exit-options{
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

</style>
<script>
	import $ from 'jquery'
	export default {
		props:['data', 'orderExistSelected'],
  		data() {
  			return {
				mesero: false,
				isDisabled: false,
				isShaking: false,
  				quantity_status: false,
  				state_stock: false,
				kiosko: localStorage.getItem('kiosko'),
  				avaliability: 0,
  				exit_component:false,
  				exit_component2:false,
  				currency: localStorage.getItem('currency'),
  				activate_observation: JSON.parse(localStorage.getItem('activate_observation').toLowerCase()),
  				an_addition:JSON.parse(localStorage.getItem('an_addition').toLowerCase()),
  				id_company: JSON.parse(localStorage.getItem('puntos'))[0].id_companie,
  				botones: null,
  				product: [],
  				combination_default_first: false,
				multiply_addition_product:false,
  				quantity: 1,
  				addition_v:0,
  				form:{
  					combination: "",
  					addition: [],
  					price: 0,
  					unit_price:0,
  					priceaux: 0,
  					quantity: 1,
          			statusCombination: false,
          			observation_optional:"",
					name_client: ''
  				},
				clients_order: [],
				new_client: "",
  				textCombination: "",
  				textAddition: ""
  			}
			
  		},
		watch:{

		},
		computed: {
			filteredVariantDetails() {
				return this.product.variant_detail.filter(
					(detail) => detail.id_product_variant == this.variant.id_product_variant
				);
			}
		},
  		methods: {
			addNewClient() {
				if (this.new_client.trim() !== "") {
				this.clients_order.push(this.new_client.trim()); // Agrega el nuevo cliente
				this.form.name_client = this.new_client.trim(); // Lo selecciona automáticamente
				this.new_client = ""; // Limpia el input
				}
			},
			handleClick() {
				if (this.isDisabled) {
					this.loadDisabled()
					this.triggerShake();
					
				} else {
					this.addToCart(this.product.id_product);
				}
			},
			triggerShake() {
				this.isShaking = true;
				if (!this.validarAddition()){
					this.exit_component2 = true;
				} else if(this.product.statusVariants && !this.form.statusCombination){
					this.isDisabled = true;
					this.exit_component = true;
				}else{
					this.exit_component = false;
					this.exit_component2 = false;
					this.isDisabled = false;
				}
				setTimeout(() => {
					this.isShaking = false;
				}, 300); // Duración del efecto (coincide con la animación en CSS)
			},
			loadDisabled(){
				if (!this.validarAddition()){
					this.isDisabled = true;
					return 0;
				} else if(this.product.statusVariants && !this.form.statusCombination){
					this.isDisabled = true;
					return false;
				}else{
					this.exit_component = false;
					this.exit_component2 = false;
					this.isDisabled = false;
				}
			},
			addQuantity(detail, limite, id_product_addition, id_product_addition_detail) {
				// Validar límite antes de incrementar
				let currentCount = this.refreshList(id_product_addition);
				
				// Si hay límite y ya se alcanzó, no permitir incrementar
				if (limite > 0 && currentCount >= limite) {
					return; // No hacer nada si se alcanzó el límite
				}

				let insert = true;
				this.quantity = this.quantity + 1;
				
				// Incrementar la cantidad del detalle
				detail.quantity += 1;
				
				// Actualizar o agregar a la lista de adiciones
				this.form.addition.forEach((item) => {
					if (item.id_product_addition_detail == id_product_addition_detail) {
						insert = false;
						item.quantity = detail.quantity;
						this.addition_v += parseFloat(detail.value);
					}
				});

				if (insert) {
					this.form.addition.push({
						id_product_addition_detail: detail.id_product_addition_detail,
						option: detail.option,
						value: detail.value,
						id_product_addition: detail.id_product_addition,
						quantity: detail.quantity
					});
					this.addition_v += parseFloat(detail.value);
				}

				this.loadDisabled();
				this.$forceUpdate();
			},

  			removeQuantity(detail, limite ,id_product_addition, id_product_addition_detail){
  				this.quantity=this.quantity-1;	
  				if (detail.quantity > 0) {
  					this.addition_v -= parseFloat(detail.value);
  					detail.quantity -= 1;
  					this.refreshList(id_product_addition);
  					this.form.addition.forEach((d)=>{if (d.id_product_addition_detail == id_product_addition_detail)d.quantity=detail.quantity;});  
  					
  				}
  				
  				//alert(valor)
  				//self.form.price-=valor;
  				if(detail.quantity == 0){
  					
  					let pos = null;
  					this.form.addition.map((item,index) => {
  						if(item.id_product_addition_detail == id_product_addition_detail)pos = index;
  					});
  					if(pos != null)this.form.addition.splice(pos,1);
  				}
				this.loadDisabled();
				this.$forceUpdate();
  			},
  			refreshList(id_product_addition){
				let contador = 0;
				this.data.product.addition_detail.forEach((item) => {
					if (item.id_product_addition == id_product_addition) {
						contador += parseInt(item.quantity) || 0;
					}
				});
				return contador;
			},
			isLimitReached(id_product_addition, limite) {
				if (limite <= 0) return false; // Sin límite
				let currentCount = this.refreshList(id_product_addition);
				return currentCount >= limite;
			},
			canAddMore(id_product_addition, limite) {
				if (limite <= 0) return true; // Sin límite
				let currentCount = this.refreshList(id_product_addition);
				return currentCount < limite;
			},

  			close(){
  				this.$emit('closeSidebar',false);
  			},
  			plus(){
  				if (this.data.product.inventory_day) {
  					if (this.avaliability > 0 && this.avaliability > this.form.quantity) {
  						this.form.quantity++;
  					}
  				}else{
  					this.form.quantity++;
  				}
  			},
  			minus(){
  				if(this.form.quantity>1)this.form.quantity--;
  			},
  			getPriceProductCombination(){
  		
  				document.getElementById("btn_agregar").style.pointerEvents = 'auto';
  				//document.getElementById("btn_agregar").style.opacity = "1";         
		      var self = this;
		      self.state_stock = false;
		      var combinaciones = this.product.variants;
		      this.form.statusCombination = false;
		      this.form.combination = false;
		      this.textCombination = "";
		      //Verificamos si todos los valores de los select son <> de 0, si es asi el caso buscamos la combinación 
		      //y extraemos el valor.
		      combinaciones.forEach((combinacion,pos) => {
		          var value = document.getElementById(combinacion.name_variant+'_'+combinacion.id_product).value; 
		          if(value != 0){
		            if(pos == 0)self.textCombination += value.split('_')[1];
		            else self.textCombination += ' - '+value.split('_')[1];
		          }
		      });
		      if(this.textCombination.length > 0){
		        this.product.variant_combination.forEach((combination) => {            
		                if(combination.variant == self.textCombination ){                  
		                  self.form.price = parseFloat(combination.value);
		                  self.form.unit_price = parseFloat(combination.value);
		                  if(self.form.price == 0){
		                    self.form.price = self.form.priceaux;

		                    var valueCombination = combination.value;
		                    valueCombination = parseFloat(combination.value);
		                    valueCombination = Math.trunc(valueCombination);
		                    self.form.price = parseFloat(self.form.price)+valueCombination;
		                    self.form.unit_price = valueCombination;
		                  }                                  
		                  //if(self.form.addition.length > 0)self.form.price+=self.addition_v;
		                  
		                  self.form.combination = combination.variant;
		                  if(self.data.product.stock.length > 0){
		                  	var encontro = false;
		                  	self.data.product.stock.forEach((item) => {
		                  			if(item.variante == self.form.combination){
		                  				self.avaliability = item.stock; 
		                  				self.state_stock = true;
		                  				encontro = true;
		                  			}
		                  	})
		                  	
		                  	if(!encontro)self.avaliability = 0;
		                  	if (self.avaliability == 0) {
		                  		document.getElementById("btn_agregar").style.pointerEvents = 'none';
		                  		document.getElementById("btn_agregar").style.opacity = "0.7";
		                  	}
		                  }
		                  self.form.statusCombination = true;
		                } 
		        }); 
		      }
			  this.loadDisabled()

		    },
		    validarAddition() {
				var self = this;
				
				// Filtrar solo las adiciones obligatorias
				let obligatorias = this.product.additions.filter(e => e.id_tipo == 139);
				
				if (obligatorias.length === 0) return true; // Si no hay obligatorias, se considera válido

				// Verificar si todas las adiciones obligatorias tienen al menos un detalle seleccionado
				let todasCumplen = obligatorias.every(e => {
					let detalles = self.product.addition_detail.filter(a => a.id_product_addition == e.id_product_addition);
					
					// Verificar si al menos uno de los detalles de esta adición ha sido seleccionado
					return detalles.some(d => self.form.addition.some(j => j.id_product_addition_detail == d.id_product_addition_detail));
				});
				return todasCumplen;
			},

		    addToCart(id_product){
				if (!this.validarAddition()){
					this.exit_component2 = true;
					return 0;
				}
				if(this.combination_default_first && this.product.variant_combination.length > 0)this.getPriceProductCombination();
				

				var self = this;
				var name_product = '';
				this.textAddition = '';
				var combi = this.form.combination.split('-'); 
				var new_product = {};
				if(this.product.variants){
					this.product.variants.forEach((v,i)=>{          
						if(i== 0)name_product += v.name_variant+':'+' '+combi[i];
						else name_product += ' - '+v.name_variant+':'+' '+combi[i];
					});
				}
				if(this.form.statusCombination){
						new_product = {
						'name_client': this.form.name_client,
						'id_product' : id_product,
						'name_product' : this.form.name+' ('+name_product+')',
						'valor': this.form.price,
						'cantidad' : this.form.quantity,
						'addition_v' : this.addition_v,
						'descuento': 0,
						'combination': this.form.combination,
						'addition': [],
						'estado' : true,
						'observation_optional': this.form.observation_optional
						} 
					//caso 1
					if(!this.product.statusAdditions)this.$emit('addItemCart',new_product);
					if(this.product.statusAdditions && this.form.addition.length == 0)this.$emit('addItemCart',new_product);
				}
				if(this.product.statusVariants && !this.form.statusCombination){
					this.exit_component = true
					return false;
				}
 

				if(this.form.addition.length > 0 && this.product.statusAdditions){
						this.form.addition.forEach((addition,pos) => {
							if (addition.quantity > 0) {
								let quantity = addition.quantity;
								self.textAddition += pos == 0 ? `${quantity}x ${addition.option}` : ` - ${quantity}x ${addition.option}`;
							}
						});
						if(Object.keys(new_product).length == 0){
							
							new_product = {
							'name_client': this.form.name_client,
							'id_product' : id_product,
							'name_product' : this.form.name+' ('+this.textAddition+')',
							'valor': this.form.price,
							'cantidad' : this.form.quantity,
							'addition_v' : this.multiply_addition_product ? this.addition_v * this.form.quantity : this.addition_v,
							'descuento': 0,
							'combination': false,
							'addition': JSON.stringify(this.form.addition),
							'estado' : true,
							'observation_optional': this.form.observation_optional
							} 	
						}else{
							new_product.addition = JSON.stringify(this.form.addition);
							new_product.name_product += ' ('+this.textAddition+')';
						}

						if (this.multiply_addition_product) {
							let addition =  JSON.parse(new_product.addition);

							addition.forEach(item => {
								item.quantity = item.quantity * new_product.cantidad;
							});

							new_product.textAddition = addition.map(item => {
								return `${item.quantity}x ${item.option}`;
							}).join(" - ");

							new_product.name_product = this.form.name+' ('+new_product.textAddition+')',

							new_product.addition = JSON.stringify(addition);
						}
					//caso 2
					if(this.form.statusCombination && this.product.statusVariants)this.$emit('addItemCart',new_product);
					if(!this.product.statusVariants)this.$emit('addItemCart',new_product);

					
					
				}else{
					new_product = {
						'name_client': this.form.name_client,
						'id_product' : id_product,
						'name_product' : this.form.name,
						'valor': this.form.price,
						'cantidad' : this.form.quantity,
						'addition_v' : this.addition_v,
						'descuento': 0,
						'combination': false,
						'addition': [],
						'estado' : true,
						'observation_optional': this.form.observation_optional
					} 
					//caso 3
					if(!this.form.statusCombination && this.product.statusAdditions)this.$emit('addItemCart',new_product);

				}
	    	},
	    	validateCheckAddition2(id_product_addition_detail,option,value,limite,id_product_addition){
	    		let numAdiciones = 0;
	    		if(limite > 0){
	    			//variable que controla el numero de adiciones que se lleva seleccionadas.>
	    			numAdiciones = this.form.addition.filter(item => item.id_product_addition == id_product_addition).length;
	    			if(limite == 1){
	    				this.form.addition.forEach((row,index) => {
	    					if(row.id_product_addition == id_product_addition){
	    						document.getElementById(row.id_product_addition_detail).checked = false;	
	    						this.form.price -= parseFloat(row.value);
	    						this.form.addition.splice(index,1);
	    					}	
	    				});
	    			}else{
	    				//Se verifica si sumando una nueva adicion se supera el limite.
	    				if((numAdiciones + 1) > limite){
	    					document.getElementById(id_product_addition_detail).checked = false;
	    				}
	    			}
	    		}
	    	},
	    	validateCheckAddition(id_product_addition_detail,option,value,limite,id_product_addition){
	    		let detail = this.form.addition.filter( item => item.id_product_addition_detail == id_product_addition_detail)[0];
	    		let numAdiciones = 0;
	    		let insert = true;
	    		if(document.getElementById(id_product_addition_detail).checked){

	    			//validamos el limite de adiciones permitido.
	    			if(limite > 0){
	    				//variable que controla el numero de adiciones que se lleva seleccionadas.>
	    				numAdiciones = this.form.addition.filter(item => item.id_product_addition == id_product_addition).length;
	    				//caso : limite = 1
	    				if(limite == 1){

	    					this.form.addition.forEach((row,index) => {
	    						if(row.id_product_addition == id_product_addition){
	    							document.getElementById(row.id_product_addition_detail).checked = false;	
	    							this.form.price -= parseFloat(row.value);
	    							this.form.addition.splice(index,1);
	    						}	
	    					});
	    				}else{
	    					//Se verifica si sumando una nueva adicion se supera el limite.
	    					if((numAdiciones + 1) > limite){
	    						document.getElementById(id_product_addition_detail).checked = false;
	    						insert = false;	
	    					}
	    				}
	    			}
	    			if(insert){
	    				this.form.addition.push({
		    				id_product_addition_detail: id_product_addition_detail,
		    				option : option,
		    				value : value,
		    				id_product_addition : id_product_addition
	    				});
	    				this.form.price += parseFloat(value);	
	    			}
	    		}else{
	    			let index = this.form.addition.indexOf(detail);
	    			this.form.addition.splice(index,1);
	    			this.form.price -= parseFloat(value);
	    		}
	    	},
			
	  		},
	  		mounted() {
	  			//alert(this.data)
	  			var self = this;
	  			this.botones = this.data.color;
	  			this.product = this.data.product;
	  			if(this.product.addition_detail.length > 0){
	  				this.product.addition_detail.map((item) => {
	  					item.quantity = 0;
	  				});
	  			}
	  			this.combination_default_first = this.data.combination_default_first;
				this.multiply_addition_product = this.data.multiply_addition_product;
	  			this.form.price = parseFloat(this.product.value);
	  			this.form.unit_price = parseFloat(this.product.value);
	  			this.form.name = this.product.name_product;

				if(location.search == "?mesero"){
					this.mesero = true;
				}

				let uniqueClients = new Set(); // Usa un Set para evitar duplicados

				if (this.orderExistSelected && this.orderExistSelected.details && this.orderExistSelected.details.length > 0) {
					this.orderExistSelected.details.forEach(detail => {
						if (detail.name_client) {
						uniqueClients.add(detail.name_client);
						}
					});
				}

				// Si no hay `name_client` en los detalles, usa `name`
				if (uniqueClients.size === 0 && this.orderExistSelected && this.orderExistSelected.name) {
					uniqueClients.add(this.orderExistSelected.name);
				}

				this.clients_order = [...uniqueClients]; // Convierte el Set en Array

			    $(window).scrollTop(0);
			    if(this.combination_default_first && this.product.variant_combination.length > 0){
	  				setTimeout(function(){ self.getPriceProductCombination() }, 500);
	  			}
				this.loadDisabled();
			}	    
	}
</script>